import SectionHeader from './section-header';
export default SectionHeader;
